import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	$backgroundImage: string;
}>`
	font-size: 1.0625rem;
	width: 21.375em;
	height: 36.0625em;
	background-color: white;
	border-radius: 16px;
	overflow: hidden;
	transform: scale(${(props) => props.scale});

	display: flex;
	flex-direction: column;
	align-items: center;
	background-position-y: bottom;
	background-position-x: left;
	background-size: cover;
	background-image: url(${(props) => props.$backgroundImage});

	@media (orientation: landscape) {
		background-position: center;
		flex-direction: row-reverse;
		font-size: 1rem;
		width: 59.75em;
		height: 25.625em;
	}
`;

export const Body = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 70%;
	height: 58%;
	gap: 0.8em;

	@media (orientation: landscape) {
		position: absolute;
		right: 4%;
		top: 17%;
		width: 50%;
		height: auto;
		gap: 0.4em;
	}
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 2.687em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.9em;
	-webkit-text-stroke-width: 0.17em;
	-webkit-text-stroke-color: #fff;
	paint-order: stroke fill;

	@media (orientation: landscape) {
		font-size: 3.25em;
		margin-top: 0.6em;
		line-height: 0.8em;
	}
`;

export const SubTitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Baloo;
	font-size: 1.25em;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25em;
	color: #fff;

	-webkit-text-stroke-width: 0.22em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	filter: drop-shadow(0 0.094em 0 #000);

	@media (orientation: landscape) {
		margin-top: 0.7em;
		padding: 0em 1.2em;
		font-size: 1.56em;
		filter: drop-shadow(0 0.08em 0 #000);
	}
`;
